import axiosWithCredentials, { API_BASE_URL } from "@/libs/apis/commons";

const getAllUserFavoriteTokensApi = (swooshHandle: string, page?: string) =>
  `${API_BASE_URL}/collections/favorites/${swooshHandle}${
    page ? `?page=${page}` : ""
  }`;

export const makeApiGetAllUserFavoriteTokensCall = async (
  swooshHandle: string,
  page?: string,
) => {
  return await axiosWithCredentials
    .get(getAllUserFavoriteTokensApi(swooshHandle, page))
    .then(({ data }) => {
      return data;
    });
};
